import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "coupontype" }

import {
  HpsfirProTable,
  HpsfirProTableColumn,
  HpsfirProTableData,
  HpsfirProTableFilter,
  HpsfirProTableGetDataFunction,
  useBaseAsync,
} from 'hpsfir-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = ref<HpsfirProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof HpsfirProTable>>();
const goodsOptions = ref<{ label: string; value: number }[]>([]);
const goodsMap = ref<Record<number, any>>({});

const addInitValue = {
};

const conditionsInitValue = {
};

// 加载商品选项
const loadGoodsOptions = useBaseAsync(async() => {
  const res = await useApi().goodsApi.listGoodsgoods({
    conditions: {},
  });
  const goodsList = res.data.data || [];
  goodsOptions.value = goodsList.map((item: any) => ({
    label: item.name,
    value: item.id,
  }));
  // 构建商品映射，便于快速查找
  goodsMap.value = goodsList.reduce((map: Record<number, any>, item: any) => {
    map[item.id] = item;
    return map;
  }, {});
});

// 创建列定义
const createColumns = () => [
  {
    name: 'name',
    label: '名称',
    type: 'string',
    isCondition: true,
    rule: [{ required: true, message: '请输入名称' }],
    width: 200,
  },
  {
    name: 'goodsId',
    label: '关联商品',
    type: 'select',
    options: goodsOptions.value,
    rule: [{ required: false, message: '请选择关联商品' }],
    width: 300,
    render(scope: any) {
      const goods = goodsMap.value[scope.row.goodsId];
      if (!goods) {
        return (<span class="no-goods">-</span>);
      }
      return (
        <div class="goods-detail">
          <div class="goods-image">
            <el-image
              src={`${useApi().baseUrl}${goods.image}`}
              fit="cover"
              style="width: 60px; height: 60px; border-radius: 4px;"
            />
          </div>
          <div class="goods-info">
            <div class="goods-name">{goods.name}</div>
            <div class="goods-desc">{goods.description || '-'}</div>
            <div class="goods-price">¥ {goods.price}</div>
          </div>
        </div>
      );
    },
  },
  {
    name: 'createTime',
    label: '创建时间',
    type: 'string',
    hideEdit: true,
    hideCreate: true,
    width: 180,
  },
] as HpsfirProTableColumn[];


// 初始化
const init = useBaseAsync(async() => {
  await loadGoodsOptions();
  columns.value = createColumns();
});

const operates: any[] = [];

const loading = ref(false);

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().couponTypeApi.pageCouponTypecouponType({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }

        conditions[key] = val;

        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您确定要删除"${row.name || '未命名'}"吗？此操作不可恢复，请谨慎操作。`;

const addFun = useBaseAsync(async(data: any) => {
  await useApi().couponTypeApi.addCouponTypecouponType({
    couponTypeAdminVo: {
      ...data,
    },
  });
  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(data: any) => {
  await useApi().couponTypeApi.updateCouponTypecouponType({
    couponTypeAdminVo: {
      ...data,
    },
  });
  ElMessage.success('修改成功');
});

const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().couponTypeApi.delCouponTypecouponType(data.id);
  ElMessage.success('删除成功');
});

Promise.all([init()]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(HpsfirProTable), {
      ref_key: "tableRef",
      ref: tableRef,
      paginations: { pageSize: 10 },
      "page-layout": "total, sizes, prev, pager, next",
      columns: columns.value,
      "get-data": _unref(getData),
      "on-add": _unref(addFun),
      "on-delete": _unref(deleteFun),
      "on-edit": _unref(updateFun),
      loading: loading.value,
      "is-dangder-delete": true,
      "format-dangder-delete-info": formatDeleteInfo,
      "row-key": "id",
      operates: operates,
      "add-init-values": addInitValue,
      "codition-init-values": conditionsInitValue
    }, null, 8, ["columns", "get-data", "on-add", "on-delete", "on-edit", "loading"])
  ]))
}
}

})